// extracted by mini-css-extract-plugin
module.exports = {"container":"SlideshowGallery_container__CBz3k"};